import { render, staticRenderFns } from "./OthreceivablesList.vue?vue&type=template&id=70eddfb8"
import script from "./OthreceivablesList.vue?vue&type=script&lang=js"
export * from "./OthreceivablesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports